
/** @jsx jsx */
import * as React from "react";
import { css, jsx } from "@emotion/core";
import { Dictionary } from "lodash";
import { InterpolationWithTheme } from "@emotion/core";

import DateRangePicker from 'react-daterange-picker';
import { DateRange } from 'moment-range';
import "react-daterange-picker/dist/css/react-calendar.css";
import './styles.scss';
import { Modal } from "react-bootstrap";

const customDatePickerStyles: Dictionary<InterpolationWithTheme<any>> = {
    buttons: {
        borderRadius: 12,
        border: "1px solid rgb(51, 94, 144)",
        background: "transparent",
        marginRight: 10,
        paddingTop: 2,
        color: "rgb(51, 94, 144)",
        fontFamily: "BrandonTextWeb-Medium",
        fontize: 14,
        fontWeight: 500
    },
    buttonsContainer: {
        margin: "10px 0px"
    },
    displayText: {
        color: "rgb(0, 0, 0)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "16px",
        margin: "10px 0"
    },
    selectedDatesContainer: {
        display: "flex",
        justifyContent: "space-around"
    },
    selectedDatesWrapper: {
        display: "flex",
        flexDirection: "column"
    },
    selectedDateLabel: {
    }
}


interface ICustomDateRangePickerProps {
    onCancel(e: React.MouseEvent<HTMLElement, MouseEvent>): void
    onOk(dates: any): void;
    isMobile: boolean
}

export const CustomDateRangePicker: React.FC<ICustomDateRangePickerProps> = props => {
    const { isMobile, onCancel, onOk } = props;
    const [selectedDates, setSelectedDates] = React.useState(null);

    const onRangeChange = (dateRange: DateRange) => {
        setSelectedDates(dateRange);
    }

    return (<Modal title="Custom Date Range" width={700} onHide={onCancel} onEnter={() => onOk(selectedDates)}>
        <div css={{ minHeight: 350 }}>
            <div css={customDatePickerStyles.buttonsContainer}>
                <button css={customDatePickerStyles.buttons}>Last 15 Days</button>
                <button css={customDatePickerStyles.buttons}>Last 1 Month</button>
                <button css={customDatePickerStyles.buttons}>Last 3 Months</button>
            </div>
            <div css={customDatePickerStyles.displayText}>or</div>
            <DateRangePicker firstOfWeek={0}
                numberOfCalendars={isMobile ? 1 : 2}
                selectionType='range'
                defaultState="available"
                singleDateRange={true}
                value={selectedDates}
                stateDefinitions={{
                    available: {
                        color: null,
                        label: 'Available',
                    },
                    enquire: {
                        color: null,
                        label: 'Enquire',
                    },
                    unavailable: {
                        color: null,
                        label: 'Unavailable',
                    },
                }}
                className="custom-date-range-selector"
                onSelect={onRangeChange as any} />

            {selectedDates &&
                <div css={customDatePickerStyles.selectedDatesContainer}>
                    <div css={customDatePickerStyles.selectedDatesWrapper}>
                        <label css={customDatePickerStyles.displayText}>Start Date</label>
                        <div css={customDatePickerStyles.selectedDate}>{selectedDates.start.format("DD-MMM-YYYY")}</div>

                    </div>
                    <div css={customDatePickerStyles.selectedDatesWrapper}>
                        <label css={customDatePickerStyles.displayText}>End Date</label>
                        <div css={customDatePickerStyles.selectedDate}>{selectedDates.end.format("DD-MMM-YYYY")}</div>
                    </div>
                </div>
            }

        </div>

    </Modal>)

}